<template>
	<transition name="v-slide">
		<div id="docPasswordWrapper" v-if="show" class="modal fade show" :style="{ display: show ? 'block' : 'none' }" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="false">
			<div class="modal-dialog align-items-end modal-dialog-center">
				<div class="modal-content">
					<button @click="show = false" type="button" class="close position-absolute" style="right: 20px; top: 15px" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="false">&times;</span>
					</button>
					<div class="modal-body text-center">
						<div v-if="submitted">
							<p class="text-uppercase" style="font-size: 1.25rem">Success!</p>

							<div v-if="link" class="form-group">
								<a :href="link" target="_blank" class="btn btn-block btn-lead">Access Document</a>
							</div>
							<div class="form-group">
								<button @click="close" type="button" class="btn btn-block btn-lead">Close</button>
							</div>
							<div class="form-group">
								<p><a href="/register/retailuser" class="text-lead" target="_blank">Click here</a> to create your own LookBookLink.
								</p>
							</div>
						</div>
						<div v-else>
							<p style="font-size: 1.25rem">Please provide the password to access {{ gallery.title }}</p>
							<form method="POST" novalidate @submit.prevent="validateForm">
								<div class="form-group">
									<input v-model="form.password" ref="docPass" type="password" class="form-control" :class="getValidationClass('password')" name="password" placeholder="Password *">
									<div class="invalid-feedback" v-for="error of v$.form.password.$errors" :key="error.$uid">{{ error.$message }}</div>
								</div>
								<div class="form-group">
									<button @click="validateForm" type="button" class="btn btn-block btn-lead">Submit</button>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
import useVuelidate from '@vuelidate/core'
import {required, requiredIf, email, minLength, helpers} from '@vuelidate/validators'
import emitter from 'tiny-emitter/instance'

export default {
	name: 'DocPassword',
	setup: () => ({v$: useVuelidate()}),
	data() {
		return {
			show: false,
			submitted: false,
			isLoading: false,
			loadingTimeout: 30000,
			vuelidateExternalResults: {},
			form: {
				password: null,
				gallery_id: null,
			},
			gallery: null,
		}
	},
	props: {
		user: Object,
	},
	watch: {
		show(after) {
			if (after) {
				document.body.style.overflowY = "hidden";
			} else {
				document.body.style.overflowY = null;
			}
		}
	},
	validations() {
		return {
			form: {
				password: {
					required: helpers.withMessage('The name field is required', required),
				}
			}
		}
	},
	created() {
		emitter.on('passwordForm', (data) => {
			console.log(data);
			if (data) {
				this.gallery = data;
				this.form.gallery_id = data.id;
				this.show = true;
				this.$nextTick(() => {
					this.$refs.docPass.focus();
				});
			}
		});
	},
	methods: {
		close() {
			this.show = false;
			this.link = null;
		},
		getValidationClass(fieldName, object = 'form') {
			const field = _.get(this.v$[object], fieldName);
			if (field && !this.isLoading) {
				return {
					'is-invalid': field.$error
				}
			}
		},
		async validateForm() {
			this.v$.$clearExternalResults()
			const isFormValid = await this.v$.form.$validate()
			if (isFormValid) {
				return this.saveData();
			}
		},
		saveData() {
			this.isLoading = true;
			axios.post(`/gallery/${ this.gallery.id }/password`, this.form)
			.then(response => {
				this.isLoading = false;
				try {
					var newWindow = window.open(response.data, '_blank');
					if (newWindow) {
						newWindow.focus();
					}
				} catch (error) {
				}
				this.link = response.data;
				this.submitted = true;
			}).catch(error => {
				this.isLoading = false;
				if (error.response.status == 422 && error.response.data.errors) {
					Object.assign(this.vuelidateExternalResults, {form: error.response.data.errors})
					return;
				}
			});
		},
	}
}
</script>
<style scoped>
.form-control {
	border-color: #404040;
}

.form-control::placeholder {
	color: #404040;
	opacity: 1;
}

.form-control:-ms-input-placeholder {
	color: #404040;
}

.form-control::-ms-input-placeholder {
	color: #404040;
}

.form-group.is-invalid .invalid-feedback {
	display: block;
}

#docPasswordWrapper {
	bottom: 0;
	top: unset;
	height: initial;
	margin-top: auto;
	overflow: visible;
	z-index: 1040;
}

@media (max-height: 700px) {
	#docPasswordWrapper {
		overflow-y: scroll;
		padding-top: 50px;
		height: 100%;
	}
}

#docPasswordWrapper .modal-content {
	box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
	border: none;
}

#docPasswordWrapper .modal-body {
	margin-top: 50px;
}


.text-lead {
	color: #404040;
}

button.text-lead:hover {
	color: #232323;
}

.btn-lead {
	background-color: #404040;
	color: #fff;
	text-transform: uppercase;
}

.btn-lead:hover, .btn-lead:active {
	background-color: #232323;
	color: #FFf;
}

.v-slide-enter-active {
	transition: all 2s ease-in-out;
}

.v-slide-enter-from,
.v-slide-leave-to {
	max-height: 0;
	height: 0;
}

.v-slide-enter-to,
.v-slide-leave-from {
	max-height: 100%;
	height: auto;
}

</style>